import {
  PaymentLotDetailBillet,
  PaymentLotDetailOnUs,
  PaymentLotDetailTed,
  PaymentLotDto,
  PaymentLotService,
  PaymentLotTypeLotEnum,
} from '@wlp/ui-bs-cashout';
import {BehaviorSubject, Observable} from 'rxjs';
import {ChangeDetectorRef} from '@angular/core';
import {ModalAlertComponent} from '../../../modals/modal-alert/modal-alert.component';
import {ModalController, NavController} from '@ionic/angular';
import {environment} from '../../../../../../../environments/environment';
import * as moment from 'moment';
import {UserInfoProfile} from "@wlp/ui-bs-login/lib/dto/user-info-profile";

export abstract class AbstractCashOut {
  protected userProfile: UserInfoProfile;
  protected toggleLotPayment = false;
  protected paymentLot: PaymentLotDto;
  protected amountPaymentLot: number;
  protected valuePaymentLot: number;
  protected behaviorToggle = new BehaviorSubject<boolean>(null);

  constructor(protected _paymentLotService: PaymentLotService,
              protected _cdr: ChangeDetectorRef,
              private _modalController: ModalController,
              private _navCtrl: NavController,) {
  }

  // ------------------------------------------------------------------------------------------------------
  // Métodos Abstratos para serem implementados nas classes de processamento de Pagamento em Lote
  // ------------------------------------------------------------------------------------------------------
  protected abstract processPaymentLot(): Promise<void>;

  protected abstract codeOperation(): string;

  protected abstract changeTextAction();

  // ------------------------------------------------------------------------------------------------------
  // Métodos de processamento de pagamento em lote genericos
  // ------------------------------------------------------------------------------------------------------
  protected isEnabledPaymentLot(paymentLotType: PaymentLotTypeLotEnum): boolean {
    if (this.userProfile && this.userProfile.rolesMenu) {
      switch (paymentLotType) {
        case PaymentLotTypeLotEnum.BILLET:
          return this.userProfile.isRoleMenu('PAYMENT_LOT_BILLET');
        default:
          return false;
      }
    }
    return false;
  }

  protected async changePaymentLot(paymentLotType: PaymentLotTypeLotEnum) {
    this.toggleLotPayment = !(await this.behaviorToggle).value;
    this.behaviorToggle.next(this.toggleLotPayment);

    console.log(this.toggleLotPayment, this.behaviorToggle);

    if (this.toggleLotPayment) {
      this.loadPaymentLot(paymentLotType);
      this.changeTextAction();
    } else {
      this.changeTextAction();
    }
  }

  protected async loadPaymentLot(paymentLotType: PaymentLotTypeLotEnum){
    switch (paymentLotType) {
      case PaymentLotTypeLotEnum.BILLET:
        this._paymentLotService.getBilletLotAvailable().subscribe( res => {
          this.paymentLot = res;
        }, error => console.error('Ocorreu erro ao tentar carregar lote ' + error),
          () => {
            this.calculatedAmountLot(paymentLotType);
            this._cdr.detectChanges();
          });
        break;
      default:
        console.warn('Tipo não parametrizado');
    }
  }

  protected addTransactionOnLot(paymentLotType: PaymentLotTypeLotEnum,
                                transaction: PaymentLotDetailBillet | PaymentLotDetailTed | PaymentLotDetailOnUs):
    Observable<PaymentLotDetailBillet | PaymentLotDetailTed | PaymentLotDetailOnUs> {
    switch (paymentLotType) {
      case PaymentLotTypeLotEnum.BILLET:
        if (!this.paymentLot) {
          return this._paymentLotService.addBilletLotByUser( transaction as PaymentLotDetailBillet);
        } else {
          return this._paymentLotService.addBilletLotTransaction( transaction as PaymentLotDetailBillet);
        }
      default:
        console.warn('Tipo não parametrizado');
    }
  }

  private calculatedAmountLot(type: PaymentLotTypeLotEnum) {
    this.amountPaymentLot = 0;
    this.valuePaymentLot = 0;
    if (this.paymentLot && this.paymentLot.data && this.paymentLot.data.length > 0 ) {
      this.amountPaymentLot = this.paymentLot.data.length;
      if (type == PaymentLotTypeLotEnum.BILLET) {
        const paymentDetail = this.paymentLot.data as Array<PaymentLotDetailBillet>;
        this.valuePaymentLot = paymentDetail.map( m => m.valuePayment).reduce((prev, next) => prev + next) ;
      } else {
        this.valuePaymentLot = this.paymentLot.data.map( m => m.value).reduce((prev, next) => prev + next) ;
      }
    }
  }

  public async modalCancelTransaction(event: any) {
    console.log('modalCancelTransaction:: ',  event, JSON.stringify(event));

    const modalStatus = await this._modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        status: 'warning-circle',
        message: 'CASH_OUT.PAYMENT_LOT.MESSAGES.CONFIRMATION_CANCEL_LOT',
        description: 'CASH_OUT.PAYMENT_LOT.MESSAGES.CONFIRMATION_DELETE',
        cancelBtn: 'CASH_OUT.PAYMENT_LOT.BUTTONS.CANCEL',
        confirmBtn: 'CASH_OUT.PAYMENT_LOT.BUTTONS.CONFIRM',
        confirmation: true,
        translate: true,
        hasActionAfterConfirmation: true,
      },
      backdropDismiss: false,
    });

    modalStatus.onDidDismiss().then((data) => {
      if (data.data) {
        console.log('cancelLot', data);
        this.cancelTransaction(event.typeLot, event.uuidTransation);
      }
    });

    return await modalStatus.present();
  }

  protected async modalCancelLot(event: any) {
    const modalStatus = await this._modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        status: 'warning-circle',
        message: 'CASH_OUT.PAYMENT_LOT.MESSAGES.CONFIRMATION_CANCEL_LOT',
        description: 'CASH_OUT.PAYMENT_LOT.MESSAGES.CONFIRMATION_WARNNING_OPERATION',
        cancelBtn: 'CASH_OUT.PAYMENT_LOT.BUTTONS.CANCEL',
        confirmBtn: 'CASH_OUT.PAYMENT_LOT.BUTTONS.CONFIRM',
        confirmation: true,
        translate: true,
        hasActionAfterConfirmation: true,
      },
      backdropDismiss: false,
    });

    modalStatus.onDidDismiss().then((data) => {
      if (data.data) {
        console.log('modalCancelLot', data);
        this.cancelLot(event.typeLot);
      }
    });

    return await modalStatus.present();
  }

  private async cancelLot(paymentLotType: PaymentLotTypeLotEnum){
    switch (paymentLotType) {
      case PaymentLotTypeLotEnum.BILLET:
        this._paymentLotService.deletedBilletLotByUser().subscribe( res => {
            this.loadPaymentLot(paymentLotType);
          }, error => {
            this.statusNotification('warning-circle', 'CASH_OUT.PAYMENT_LOT.MESSAGES.ERROR_OPERATION_1', null, true);
            console.error('Ocorreu erro ao tentar cancelar o lote ' + error);
          },
          () => {

            this._cdr.detectChanges();
          });
        break;
      default:
        console.warn('Tipo não parametrizado');
    }
  }

  private async cancelTransaction(paymentLotType: PaymentLotTypeLotEnum, uuidTransaction: string){
    switch (paymentLotType) {
      case PaymentLotTypeLotEnum.BILLET:
        this._paymentLotService.deletedBilletLotTransaction(uuidTransaction).subscribe( res => {
            this.loadPaymentLot(paymentLotType);
          }, error => {
            this.statusNotification('warning-circle', 'CASH_OUT.PAYMENT_LOT.MESSAGES.ERROR_OPERATION_1', null, true);
            console.error('Ocorreu erro ao tentar cancelar a transação ' + error);
          },
          () => {
            this._cdr.detectChanges();
          });
        break;
      default:
        console.warn('Tipo não parametrizado');
    }
  }

  protected async processPayment(paymentLotType: PaymentLotTypeLotEnum, token: string){
    switch (paymentLotType) {
      case PaymentLotTypeLotEnum.BILLET:
        this._paymentLotService.processBillet(token, this.paymentLot._id, environment.wlp).subscribe( res => {
          let messageReturn = null;

          if (res.isApproved) {
            messageReturn = res.message;
          }

          this.toggleLotPayment = false;
          this.loadPaymentLot(PaymentLotTypeLotEnum.BILLET);

          this.statusNotification('success', 'CASH_OUT.PAYMENT_LOT.MESSAGES.SUCCESS_OPERATION_1',
              (!messageReturn ? 'CASH_OUT.PAYMENT_LOT.MESSAGES.SUCCESS_OPERATION_2' : messageReturn ), true);
        }, error => {
          console.error('Ocorreu erro ao tentar carregar lote ' + error);
          this.statusNotification('warning-circle', 'CASH_OUT.PAYMENT_LOT.MESSAGES.ERROR_OPERATION_1', null, true);
        },
        () => {
          this._cdr.detectChanges();
        });
        break;
      default:
        console.warn('Tipo não parametrizado');
    }
  }

  private async statusNotification(status: string, message: string, description: string, translateFlag: boolean) {

    const translate = translateFlag ? true : false;
    const modalStatus = await this._modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        status: status,
        message: message,
        description: description,
        confirmBtn: 'CASH_OUT.PAYMENT_LOT.BUTTONS.CLOSED',
        translate: translate,
        hasActionAfterConfirmation: true,
      },
      backdropDismiss: false,
    });
    return await modalStatus.present();
  }

  protected formattedPipeDate(date: any) {
    console.log('formattedPipeDate ' +  date);

    return moment(date.replaceAll('/', '-').split('-').reverse().toString().replaceAll(',', '-')).format('YYYY-MM-DD');
  }

}
